import { render, staticRenderFns } from "./CreateProposalModal.vue?vue&type=template&id=6bceb030&scoped=true&"
import script from "./CreateProposalModal.vue?vue&type=script&lang=js&"
export * from "./CreateProposalModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bceb030",
  null
  
)

export default component.exports